module.exports = __webpack_public_path__ + "img/step6.cad8ece9.png";